import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { ConnectUserInfoOverrides } from "./getConnectUserInfoOverrides";

export interface SaveConnectUserInfoOverridesResponse extends BackendResponse {}

export interface SaveConnectUserInfoOverridesParameters extends NextApiParams {
  overrides: ConnectUserInfoOverrides;
}

export const saveConnectUserInfoOverrides = withNextApi<
  SaveConnectUserInfoOverridesResponse,
  SaveConnectUserInfoOverridesParameters
>("/auth/SaveConnectUserInfoOverrides", { method: "POST" });
